import { render, staticRenderFns } from "./global.vue?vue&type=template&id=643af966&scoped=true&"
import script from "./global.vue?vue&type=script&lang=js&"
export * from "./global.vue?vue&type=script&lang=js&"
import style0 from "./global.vue?vue&type=style&index=0&id=643af966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643af966",
  null
  
)

export default component.exports